import React from 'react';
import { SparklesIcon, PaletteIcon, LeafIcon, ZapIcon } from 'lucide-react';
export const WhySection = () => {
  const benefits = [{
    icon: SparklesIcon,
    title: 'Unmatched Taste',
    description: 'Still, sparkling, and mineral water that actually tastes extraordinary.'
  }, {
    icon: PaletteIcon,
    title: 'Design-Forward',
    description: 'A beautiful countertop system that elevates any bar, café, spa, or office.'
  }, {
    icon: LeafIcon,
    title: 'Sustainable',
    description: 'No plastic bottles. No transport. Just pure water on site.'
  }, {
    icon: ZapIcon,
    title: 'Effortless Service',
    description: 'Simple to operate, always ready, and easy to maintain.'
  }];
  return <section className="py-16 md:py-32 water-texture" data-id="element-232">
      <div className="container mx-auto px-4 md:px-6 lg:px-12" data-id="element-233">
        <div className="text-center mb-12 md:mb-24" data-id="element-234">
          <h2 className="text-3xl md:text-6xl font-light mb-4 md:mb-6" data-id="element-235">
            Why WELLHAUS™?
          </h2>
          <p className="text-lg md:text-2xl text-gray-600 font-light" data-id="element-236">
            Water that guests actually remember.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 max-w-7xl mx-auto" data-id="element-237">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="glass-card p-6 md:p-8 rounded-xl md:rounded-2xl text-center space-y-3 md:space-y-4" data-id="element-238">
                <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-water-blue" data-id="element-239">
                  <Icon size={24} className="text-water-accent md:w-7 md:h-7" data-id="element-240" />
                </div>
                <h3 className="text-lg md:text-xl font-medium" data-id="element-241">
                  {benefit.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-600 leading-relaxed" data-id="element-242">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
};